import {ChangeDetectorRef, Component, OnDestroy, OnInit, Renderer2} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { filterBy, process } from '@progress/kendo-data-query';
import { Subscription } from 'rxjs';
import { DQOIReferenceDataQuery } from '../../dqoi/state/dqoi-reference-data.query';
import { BaseGridEditFormLinesComponent } from '../../shared/base-components/base-grid-edit-formlines.component';
import { CPDialogResult } from '../../shared/enums/CPDialogResult';
import { CRUDActions } from '../../shared/enums/CRUDActions';
import { BaseMessageInfo } from '../../shared/models/BaseMessageInfo';
import { ConfirmOutput } from '../../shared/models/ConfirmOutput';
import { DQOIReferenceData } from '../../shared/models/DQOIReferenceData';
import { GItem } from '../../shared/models/GItem';
import { MessageInfo } from '../../shared/models/MessageInfo';
import { SystemEventBus } from '../../shared/models/SystemEventBus';
import { SystemEventSubscriptionsBus } from '../../shared/models/SystemEventSubscriptionsBus';
import { GlobalsService } from '../../shared/services/globals.service';
import { SystemService } from '../../shared/services/system.service';
import { CommonFunctions } from '../../shared/static/common-functions';
import { DateFunctions } from '../../shared/static/date-functions';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { Message } from '@app/cp/shared/models/message';
import { v_InventoryBus } from '@app/cp/shared/models/v_InventoryBus';
import { ColumnComponent } from '@progress/kendo-angular-grid';

@Component({
    selector: 'cp-event-manager',
    templateUrl: './event-manager.component.html',
    styleUrls: ['./event-manager.component.scss']
})
export class EventManagerComponent extends BaseGridEditFormLinesComponent<SystemEventSubscriptionsBus, null, SystemService> implements OnDestroy {

    dialogOpened: boolean = false;
    formActive = false;
    searchTerm: string = '';
    subs_dataRef: Subscription;
    subs_dataEvents: Subscription;
    events: SystemEventBus[];
    constAdmins: GItem[] = [];
    contractStatuses: GItem[] = [];
    subs_dataRefUpdated: Subscription;
    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: SystemService, private _qry_rd: DQOIReferenceDataQuery,  public featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;
        this.subs_dataRef = this._qry_rd.ensureRefDataIsLoaded(this.globals.companyId).subscribe();
        this.disableCpSearchDialog();
        this.subs_dataRefUpdated = this._qry_rd.referenceDataUpdated.subscribe((data: DQOIReferenceData) => {
            if (!data) {
                return;
            }
            this.referenceData = data;
            this.constAdmins = this.referenceData.getActiveContAdmins();
        });
  
        this.className = "SystemEventSubscriptionsBus";
        this.appCode = "SystemEventSubscriptions";
        this.refreshRefference();
        this.allData = this.allData.bind(this);
        this.getEventData();
        this.getData();
    }
    override ngOnDestroy(): void {
        super.ngOnDestroy();
        CommonFunctions.unsubscribe(this.subs_dataRef);
        CommonFunctions.unsubscribe(this.subs_dataRefUpdated);
    }
    public static virtualizationSettings = { itemHeight: 30, pageSize: 100 };
    exportFilteredData: any[];
    public allData(indata: ExcelExportData): ExcelExportData {
        if (!this.gridData) this.exportFilteredData = [];
        const result: ExcelExportData = {
            data: process(this.gridData as any, {}).data,
        };
        return result;
    }
    mainDataLoading: boolean = false
    public exportGridToExcel(): void {
        this.printing = true;
        this.mainDataLoading = true;
        setTimeout(() => {
            this.grid.saveAsExcel();
            this.printing = false;
            this.mainDataLoading = false;
        },
            1000);
    }
    printing: boolean = false;
    showFailCollection: boolean = false;
    showSuccessCollection: boolean = false;
    msgFail: string = "";
    msgSuccess: string = "";
    importErrors: MessageInfo[] = [];
    updatedRecords: number = 0;
    insertedRecords: number = 0;
    deletedRecords: number = 0;
    createForm() {
        this.editForm = new UntypedFormGroup({
            'eventSubscriptionsId': new UntypedFormControl(),
            'systemEventId': new UntypedFormControl("", Validators.required),
            'customerId': new UntypedFormControl(),
            'locationId': new UntypedFormControl(),
            'instanceDays': new UntypedFormControl(),
            'instances': new UntypedFormControl(),
            'insertDt': new UntypedFormControl(),
            'serviceManagerId': new UntypedFormControl(),
            'accountManagerId': new UntypedFormControl(),
            'regionId': new UntypedFormControl(),
            'divisionId': new UntypedFormControl(),
            'onCallRegionId': new UntypedFormControl(),
            'contractAdminId': new UntypedFormControl(),
            'billerId': new UntypedFormControl(),
            'dispatchStatusId': new UntypedFormControl(),
            'contractStatusId': new UntypedFormControl(),
            'jobStatusId': new UntypedFormControl(),
            'companyBranchId': new UntypedFormControl(),
            'subscribedEmail': new UntypedFormControl("", Validators.required)
        });
    }
    setForm() {

        if (!this.selectedData.insertDt) {
            this.selectedData.insertDt = DateFunctions.getDateNow();
        }
        this.editForm.patchValue({
            eventSubscriptionsId: this.selectedData.eventSubscriptionsId,
            systemEventId: this.selectedData.systemEventId,
            customerId: this.selectedData.customerId,
            locationId: this.selectedData.locationId,
            instanceDays: this.selectedData.instanceDays,
            instances: this.selectedData.instances,
            serviceManagerId: this.selectedData.serviceManagerId,
            accountManagerId: this.selectedData.accountManagerId,
            subscribedEmail: this.selectedData.subscribedEmail,
            regionId: this.selectedData.regionId,
            divisionId: this.selectedData.divisionId,
            onCallRegionId: this.selectedData.onCallRegionId,
            billerId: this.selectedData.billerId,
            dispatchStatusId: this.selectedData.dispatchStatusId,
            contractStatusId: this.selectedData.contractStatusId,
            jobStatusId: this.selectedData.jobStatusId,
            companyBranchId: this.selectedData.companyBranchId,
            contractAdminId: this.selectedData.contractAdminId,
            insertDt: this.selectedData.insertDt

        });
        this.customerChanged(this.selectedData.customerId)
    }
    //subs_data_ref: Subscription;
    //employeeReferenceData: EmployeeReference = new EmployeeReference();
    //setFromReferenceData(data: UnionBenefitsBus) {
    //    data.union = this.employeeReferenceData.getUnion(data.unionId);
    //    data.jobRole = this.employeeReferenceData.getJobRoleDescription(data.jobRoleId);
    //    data.applyTypeDesc = this.employeeReferenceData.getApplyType(data.applyType);

    //    return data;
    //}
    refreshRefference() {

        //if (this.subs_data_ref !== undefined && this.subs_data_ref !== null) {
        //    this.subs_data_ref.unsubscribe();
        //}
        //this.subs_data_ref = this.svc_employee_data.GetReferenceData().subscribe(data => {

        //    this.employeeReferenceData = new EmployeeReference(data);

        //    var gi = new GItem()
        //    gi.value = "130af401-d045-416e-9204-79bbf44abfd9";
        //    gi.description = "All Job Roles"
        //    this.employeeReferenceData.jobRoles.unshift(gi);
        //});
    }
    confirmDialog(data: ConfirmOutput) {
        this.closeCtrlOpenFlag = true;
        if (data.dialogResult === CPDialogResult.ok) {
            switch (data.action) {
                case CRUDActions.Delete:
                    this.delete(data.data.eventSubscriptionsId);
                    break;
            }
        }
    }

    save() {
        var busObj = new SystemEventSubscriptionsBus(null);
        busObj.setFromForm(this.editForm.value);
        this.svc_data.saveSystemEventSubscription(busObj).toPromise().then((data: BaseMessageInfo) => {
            if (data != null && !data.saveError) {
                let newDataObj: SystemEventSubscriptionsBus = new SystemEventSubscriptionsBus();
                this.notify(this.appCode + " Saved Successfully!");
                this.getData();
                this.formActive = false;
            }
            else {
                let retInfo: BaseMessageInfo = new BaseMessageInfo();
                retInfo.message = "Error Saving System Event"
                retInfo.saveError = true;
                this.saveError(null, retInfo.message);
            }

        });
    }

    delete(id:any) {

        this.svc_data.deleteSystemEventSubscriptions(id).toPromise().then((data: BaseMessageInfo) => {
            if (data != null && !data.saveError) {
                this.notify(this.appCode + " Deleted Successfully!");
                this.getData();
                this.formActive = false;
            }
            else {
                let retInfo: BaseMessageInfo = new BaseMessageInfo();
                retInfo.message = "Error Deleting System Event"
                retInfo.saveError = true;
                this.saveError(null, retInfo.message);
            }

        });
    }

    get canAddEdit(): boolean {
        return (!this.readOnly ) ? true : false;
    }
    deleteIndividual(data: SystemEventSubscriptionsBus) {
        //this.svc_data.deleteUnionBenefitLine(data.unionBenefitLookupId).subscribe((retData: UnionBenefitMessageInfo) => {
        //    if (retData.saveError) {
        //        this.notify(CommonValues.Message_ErrorDeleting + " - " + retData.message, 'E');
        //    }
        //    else {
        //        this.removeLocal(data);
        //        this.notify(CommonValues.Message_SuccessfullyDeleted);

        //    }
        //});

    }
    reFilterData() {
        this.gridData = filterBy(this.originalData, this.filter);

    }

    closeWindow() { this.dialogOpened = false; }
    cancelInput() {
        this.formActive = false;
        this.editForm = null;
    }

    saveInput() {
        this.formActive = false;
    }
    public addHandler(): void {
        if (!this.editForm) {
            this.createForm();
            this.selectedData = new SystemEventSubscriptionsBus();
            this.setForm()
        }
        this.formActive = true;
    }

    public edittheform(data){
        this.createForm();
        this.selectedData = data
        this.setForm()
        this.formActive = true;
    }

    customerCBOChanged(item: any) {
        if (CommonFunctions.hasValue(item)) {

            this.customerChanged(item.value);
            //            this.customerChanged(item.value);
        }
        else {
            this.customerChanged(null);
        }
    }
    locationIds: string[];
    customerLocations: GItem[] = [];
    customer: string;
    location: string;
    customerChanged(id: any, holdLocationChange: boolean = false) {
        this.location = null;
        let custId: any = id;
        if (CommonFunctions.hasValue(this.referenceData) && CommonFunctions.hasArrayValue(this.referenceData.locations) && CommonFunctions.hasValue(id)) {
            this.customer = this.referenceData.getCustomerDesc(id); // .customers.find(s => s.value === id).description;
            this.customerLocations = this.referenceData.locations.filter(e => e.category === id);
            this.locationIds = [];
        }
        else {
            this.customer = null;
            //  this.editForm.value.customerId = null;
            this.customerLocations = [];
        }
        //this.sendDQOIMessage(this.customer, this.location);
    }
    getData() {
        this.mainDataLoading = true;
        this.svc_data.getSystemEventSubscriptions().subscribe((data: BaseMessageInfo) => {
            if (!data.warning) {
                 let list = [];
                if (CommonFunctions.hasArrayValue(data.primaryReturn)) {
                    for (let i = 0; i < data.primaryReturn.length; i++) {
                        let newObj: SystemEventSubscriptionsBus = this.setFromReferenceData(new SystemEventSubscriptionsBus(data.primaryReturn[i]))
                        if (this.referenceData) {
                            newObj.companyBranch = this.referenceData.getCompanyBranch(newObj.companyBranchId)
                            newObj.biller = this.referenceData.getPerson(newObj.billerId);
                            newObj.accountManager = this.referenceData.getPerson(newObj.accountManagerId);
                            newObj.contractAdmin = this.referenceData.getPerson(newObj.contractAdminId);
                        }
                        list.push(newObj);
                    }
                }
                this.gridData = list;
                this.cloneData();
            }
            if (data.warning) {
                alert('data.warning');
            }
            this.mainDataLoading = false;
        });
    }
    getEventData() {
        this.mainDataLoading = true;
        this.svc_data.getSystemEvents().subscribe((data: BaseMessageInfo) => {
            if (!data.warning) {
                let list = [];
                if (CommonFunctions.hasArrayValue(data.primaryReturn)) {
                    for (let i = 0; i < data.primaryReturn.length; i++) {
                        let newObj: SystemEventBus = new SystemEventBus(data.primaryReturn[i])
                        list.push(newObj);
                    }
                }
                this.events = list;

            }
            if (data.warning) {
            }

        });
    }

    search(searchTerm: string){
        if (searchTerm) {
            let dataToSearch = this.originalData;
            let result = dataToSearch.filter( s => s.eventName.toLowerCase().search(searchTerm.toLowerCase()) >= 0 );
            console.log(result);
            this.gridData = result;
        } else {
            this.gridData = this.originalData;
        }
    }

    splitEmail(emails) {
        const splitEmails = emails.split( /[ ,]+/ );
        console.log( 'splitEmails ' + splitEmails );
        return splitEmails.map( item => item.trim() );
    }
    public viewType: string = 'cards';
    switchView(viewType: string){
            this.viewType = viewType;
    }

    setIcon(type: any){
        let icon = ''
        let color = ''
        switch (type) {
            case ('construction'):
            case ('14760776-62e3-48b8-bc46-3090fc5fdbc3'):
            case ('60016ff4-6a2c-483a-862f-085f876a9e8b'):
                icon = 'fa-toolbox'
                color = 'orange';
                break;

            case ('customer'):
            case ('189c3a74-9b45-489a-80cb-ea0abb5f9fe4'):
            case ('c47abe59-72a7-49ea-9b17-6c17197223f3'):
                icon = 'fa-building'
                color = 'pink';
                break;

            case ('dispatch'):
            case ('e2547b6a-9e3d-4b86-9bcf-2e3c20d7d285'):
            case ('15671631-7943-4a43-a9dc-e494aabc9c0f'):
            case ('5954db8c-e633-4f36-9efb-e07fd007d83a'):
            case ('f3f8ddda-ee46-4942-b07d-053ce449de12'):
            case ('66376455-d2b3-4ffb-9f49-186c1c2b0aa3'):
            case ('aa49303b-f81f-42dd-b8b0-71ccf5ea1d32'):
            case ('dc981e89-6ce5-44fd-9ec0-5db190cfef2e'):
            case ('083a211d-0754-4807-9c05-5e3ae1886fc3'):
            case ('3f936667-072c-45b8-a183-45c904e045e2'):
                icon = 'fa-phone'
                color = 'blue';
                break;

            case ('invoice'):
            case ('4769a709-c923-4d02-9f69-ceb3179c7de8'):
            case ('ab87cce2-ea03-4460-87c3-7d44cf8d053d'):
            case ('354542bc-efd7-43f5-b0e7-4e824ac1cf03'):
            case ('0a093e12-8fad-48da-a9dc-1fdd37a6acf6'):
            case ('9b1f2bc1-a0fc-498d-80e9-96529954e96d'):
                icon = 'fa-dollar-sign'
                color = 'green';
                break;

            case ('quote'):
            case ('e5a7ceba-1b24-44ac-8adb-97e1a5962e25'):
            case ('e6492e83-d6ac-42de-bd46-a589deb1058b'):
            case ('d047b27a-e91a-40ca-bf9f-664ba27100b9'):
            case ('ecf9aac5-043b-424b-b0b1-082e12ff0879'):
                icon = 'fa-quote-right'
                color = 'yellow';
                break;

            case ('order'):
            case ('a60ff477-4a13-49f5-b2a3-7b495eb175ef'):
            case ('c1fd9545-9f37-454a-a017-06d8f1d9b26a'):
            case ('28ba9c1c-7576-43fe-8f59-9437c794f30d'):
                icon = 'fa-receipt'
                color = 'purple';
                break;

            case ('inventory'):
            case ('ead1be33-1515-4bad-ad3b-2a23794d2f2a'):
            case ('80f31f05-7159-4a78-932e-07ffe7feb3a3'):
            case ('7609e964-7e48-45ce-99f2-437875f67a90'):
            case ('40298c24-3447-473d-b9f1-6a9a83172e2e'):
            case ('b0b42689-18a7-4193-ba04-6d72b249fa24'):
                icon = 'fa-inventory'
                color = 'teal';
                break;

            case ('mobile'):
            case ('08f695a3-094b-4805-8c71-9644a46afc82'):
            case ('dc873df7-cee6-4668-87d0-5fae07178b3f'):
            case ('d0f94e0f-549f-4fbd-a309-8e3b881c2ba4'):
            case ('1878a860-1e21-4344-8c8d-08cffaa6b468'):
            case ('e4ce2134-dad7-439e-8d49-a81aade41822'):
            case ('40e7887c-7dcd-4248-b88b-ba3ab89f0ae8'):
            case ('ab6c1b65-0a23-417f-9096-322e22c44b2c'):
            case ('0a3b1f68-64d7-471c-9ffd-f1585b523d16'):
            case ('fa16b82d-aebe-488b-92cf-732707510e06'):
            case ('ae1fca37-65c4-4a35-a556-87a464ed4895'):
            case ('93195bd2-f586-4984-8a79-355187501524'):
            case ('72de9b93-09f1-4c57-ab25-bfc8cfbdbe40'):
            case ('c987258b-7c98-439a-94b2-9a714633d8ed'):
                icon = 'fa-mobile-alt'
                color = 'darkBlue';
                break;

            case ('expenses'):
            case ('33eaf0c2-e6ea-4a52-a3cd-0f08ac617a63'):
            case ('b05bc106-0ffc-4733-a818-c3ab82f58c99'):
                icon = 'fa-hand-holding-usd'
                color = 'red';
                break;

            case ('project portal'):
            case ('a2ae607c-5c04-4b6e-9f79-a77dff2203ce'):
            case ('d39c550d-eae7-4d95-b7f8-2ca9141e48ce'):
                icon = 'fa-bolt'
                color = 'brown';
                break;

            case ('hr'):
            case ('7ae4fe5a-bf4c-4341-afa0-c1ca6855b104'):
                icon = 'fa-star-of-life'
                color = 'black';
                break;

            case ('fleet'):
            case ('377be9a7-88aa-4c52-885c-26149d1ca23e'):
            case ('52a743a7-47c2-4a3a-b235-8f51e0f3d418'):
            case ('420805f2-5db3-419f-85a4-3d6b8c677967'):
                icon = 'fa-truck'
                color = 'lightGrey';
                break;
        }
        return icon + ' ' + color;
    }

}
